import React from 'react'
import useItems from '../../../hooks/use-facilitators'
import { find } from 'lodash'

const LabelItem = ({
    facilitatorId,
    formal = false
}) => {
    const [ items ] = useItems()
    const item = find(items, { id: facilitatorId })
    if (!item) {
        return null;
    }

    if (formal) {
        return (
            <>{item.firstName} {item.lastName}</>
        )
    }
    

    return (
        <React.Fragment>{item.name}</React.Fragment>
    )
}

export default LabelItem